module.exports = __webpack_public_path__ + "img/huxi.cb951df7.png";